import styled from 'styled-components'

import MEDIA from 'constants/media'

import AgeIcon from 'assets/images/icons/grid-icons/Age.svg'
import BirthCertificate from 'assets/images/icons/grid-icons/BirthCertificate.svg'
import BurglaryIcon from 'assets/images/icons/grid-icons/Burglary.svg'
import BurstPipeIcon from 'assets/images/icons/grid-icons/BurstPipe.svg'
import Cake from 'assets/images/icons/grid-icons/Cake.svg'
import ComputerDamage from 'assets/images/icons/grid-icons/ComputerDamage.svg'
import CreditIcon from 'assets/images/icons/grid-icons/Credit.svg'
import DriversLicense from 'assets/images/icons/grid-icons/DriversLicense.svg'
import DrivingRecordIcon from 'assets/images/icons/grid-icons/DrivingRecord.svg'
import FallingTreeIcon from 'assets/images/icons/grid-icons/FallingTree.svg'
import FireIcon from 'assets/images/icons/grid-icons/Fire.svg'
import GenderIcon from 'assets/images/icons/grid-icons/Gender.svg'
import Health from 'assets/images/icons/grid-icons/Health.svg'
import HighRiskIcon from 'assets/images/icons/grid-icons/HighRisk.svg'
import HVACIcon from 'assets/images/icons/grid-icons/HVAC.svg'
import InjuryIcon from 'assets/images/icons/grid-icons/Injury.svg'
import LetterA from 'assets/images/icons/grid-icons/LetterA.svg'
import LetterB from 'assets/images/icons/grid-icons/LetterB.svg'
import LetterC from 'assets/images/icons/grid-icons/LetterC.svg'
import LicenseIcon from 'assets/images/icons/grid-icons/License.svg'
import Location from 'assets/images/icons/grid-icons/Location.svg'
import MakeModelIcon from 'assets/images/icons/grid-icons/MakeModel.svg'
import MarriageIcon from 'assets/images/icons/grid-icons/Marriage.svg'
import MileageIcon from 'assets/images/icons/grid-icons/Mileage.svg'
import MilitaryID from 'assets/images/icons/grid-icons/MilitaryID.svg'
import Occupation from 'assets/images/icons/grid-icons/Occupation.svg'
import Passport from 'assets/images/icons/grid-icons/Passport.svg'
import Period from 'assets/images/icons/grid-icons/Period.svg'
import Salary from 'assets/images/icons/grid-icons/Salary.svg'
import VINIcon from 'assets/images/icons/grid-icons/VIN.svg'
import WindIcon from 'assets/images/icons/grid-icons/Wind.svg'
import ZIPCodeIcon from 'assets/images/icons/grid-icons/ZIPCode.svg'

import {
  Props,
  Theme,
} from './types'

/* eslint-disable import/prefer-default-export */
export const Icon = styled.span`
  display: inline-block;
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  height: 80px;
  width: 140px;
  margin-bottom: 10px;
  ${MEDIA.medium`
    height: 90px;
    width: 140px;
  `}

  ${(props: Props): string | undefined => (props.theme === Theme.age && `
    background-image: url(${AgeIcon});
    background-size: 70px auto;
  `) || (props.theme === Theme.creditHistory && `
    background-image: url(${CreditIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.drivingRecord && `
    background-image: url(${DrivingRecordIcon});
    background-size: 50px auto;
  `) || (props.theme === Theme.gender && `
    background-image: url(${GenderIcon});
    background-size: 100px auto;
  `) || (props.theme === Theme.highRisk && `
    background-image: url(${HighRiskIcon});
    background-size: 115px auto;
  `) || (props.theme === Theme.license && `
    background-image: url(${LicenseIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.makeAndModel && `
    background-image: url(${MakeModelIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.maritalStatus && `
    background-image: url(${MarriageIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.mileage && `
    background-image: url(${MileageIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.vin && `
    background-image: url(${VINIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.zip && `
    background-image: url(${ZIPCodeIcon});
    background-size: 50px auto;
  `) || (props.theme === Theme.burglary && `
    background-image: url(${BurglaryIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.burstPipe && `
    background-image: url(${BurstPipeIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.fallingTree && `
    background-image: url(${FallingTreeIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.fire && `
    background-image: url(${FireIcon});
    background-size: 60px auto;
  `) || (props.theme === Theme.hvac && `
    background-image: url(${HVACIcon});
    background-size: 50px auto;
  `) || (props.theme === Theme.injury && `
    background-image: url(${InjuryIcon});
    background-size: 60px auto;
  `) || (props.theme === Theme.wind && `
    background-image: url(${WindIcon});
    background-size: 80px auto;
  `) || (props.theme === Theme.computerDamage && `
    background-image: url(${ComputerDamage});
    background-size: 80px auto;
  `) || (props.theme === Theme.letterA && `
    background-image: url(${LetterA});
    background-size: 80px auto;
  `) || (props.theme === Theme.letterB && `
    background-image: url(${LetterB});
    background-size: 80px auto;
  `) || (props.theme === Theme.letterC && `
    background-image: url(${LetterC});
    background-size: 80px auto;
  `) || (props.theme === Theme.birthCertificate && `
    background-image: url(${BirthCertificate});
    background-size: 70px auto;
  `) || (props.theme === Theme.driversLicense && `
    background-image: url(${DriversLicense});
    background-size: 90px auto;
    background-position: center;
  `) || (props.theme === Theme.militaryID && `
    background-image: url(${MilitaryID});
    background-size: 60px auto;
  `) || (props.theme === Theme.passport && `
    background-image: url(${Passport});
    background-size: 70px auto;
  `) || (props.theme === Theme.cake && `
    background-image: url(${Cake});
    background-size: 70px auto;
  `) || (props.theme === Theme.health && `
    background-image: url(${Health});
    background-size: 70px auto;
  `) || (props.theme === Theme.location && `
    background-image: url(${Location});
    background-size: 40px auto;
  `) || (props.theme === Theme.occupation && `
    background-image: url(${Occupation});
    background-size: 70px auto;
  `) || (props.theme === Theme.period && `
    background-image: url(${Period});
    background-size: 70px auto;
  `) || (props.theme === Theme.salary && `
    background-image: url(${Salary});
    background-size: 70px auto;
  `) || undefined}
`
